// extracted by mini-css-extract-plugin
export default {"title":"formTextControl_title__HGePU","content":"formTextControl_content__o6xQe","formRoot":"formTextControl_formRoot__WbgVq"};